var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -4.21586,
    y: 4.99019,
    width: 131.761,
    height: 131.795
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(9.9px)",
      clipPath: "url(#bgblur_0_709_44239_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 19.7998
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.6648,
    cy: 70.8875,
    rx: 46.0808,
    ry: 46.0974,
    fill: "url(#paint0_linear_709_44239)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.665 24.9219C87.0417 24.922 107.613 45.5017 107.613 70.8877C107.613 96.2736 87.0416 116.852 61.665 116.853C36.2883 116.853 15.7159 96.2737 15.7158 70.8877C15.7158 45.5016 36.2883 24.9219 61.665 24.9219Z",
    stroke: "url(#paint1_linear_709_44239)",
    strokeOpacity: 0.5,
    strokeWidth: 0.263998
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_709_44239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.917 22C32.3953 22 10 44.4034 10 71.9351C10 99.4668 32.3953 121.882 59.917 121.882C87.4387 121.882 109.834 99.4783 109.834 71.9466C109.834 44.4149 87.4387 22 59.917 22ZM81.4252 62.4159L56.4609 89.3023C55.3319 90.5239 53.7882 91.1462 52.233 91.1462C50.8967 91.1462 49.5719 90.6852 48.4774 89.7632L35.0334 78.2389C32.6141 76.1645 32.3376 72.5343 34.4113 70.1142C36.4849 67.6941 40.1138 67.406 42.533 69.4919L51.7722 77.4091L72.9693 54.5794C75.1351 52.2514 78.7755 52.1132 81.1141 54.2797C83.4527 56.4463 83.5794 60.088 81.4252 62.4159Z",
    fill: "url(#paint2_linear_709_44239)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_709_44239_clip_path",
    transform: "translate(4.21586 -4.99019)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.6648,
    cy: 70.8875,
    rx: 46.0808,
    ry: 46.0974
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_709_44239",
    x: 0,
    y: 0,
    width: 131.834,
    height: 131.882,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: -6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.458824 0 0 0 0 0.929412 0 0 0 0 0.631373 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_709_44239"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_709_44239",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_709_44239",
    x1: 101.211,
    y1: 41.4386,
    x2: -13.6371,
    y2: 25.5639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.61
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_709_44239",
    x1: 25.5118,
    y1: 55.717,
    x2: 103.77,
    y2: 56.1488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_709_44239",
    x1: 32.2034,
    y1: 57.4919,
    x2: 128.197,
    y2: 141.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75EDA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#349256"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.4ce4e3ad6488a2478c8adaabe391c916.svg";
export { ForwardRef as ReactComponent };